<div>
  <h1>Турниры</h1>
  <div class="boxOfRecords">
    <div
      class="tournamentRecordStyle"
      *ngFor="let tournamentRecord of tableContent"
    >
      <div
        class="dateAndTimeStyle"
      >
        <div>
          {{getTournamentStartDate(tournamentRecord)}}
        </div>
        <div>
          {{getTournamentStartHourAndMinutes(tournamentRecord)}}
        </div>
      </div>
      <div
        class="tournamentTitleStyle"
      >
        <a class="tournamentTitleStyle" href="/tournament/{{ getTournamentId(tournamentRecord) }}">
          {{getTournamentName(tournamentRecord)}}
        </a>
      </div>
    </div>
  </div>
</div>
